export class ControlState {
  disabled: boolean;
  visible: boolean;

  public constructor() {
    this.disabled = false;
    this.visible = true;
  }
}
